<template>
  <div class="card" style="height:100%; font-size:14px;">
    <div class="card-header">
      <h3 class="card-title" style="margin-top: 7px">
        Müşteri İnsiyatif Raporu
      </h3>
    </div>
    <!-- /.card-header -->
    <div class="card-body table-responsive p-0" style="height:500px">
      <div class="overlay-wrapper">
        <div class="overlay" v-if="overlay">
          <i class="fas fa-3x fa-spinner fa-spin"></i>
        </div>
        <table
          class="table table-head-fixed text-nowrap table-striped projects"
        >
          <thead>
            <tr>
              <th>#</th>
              <th>İşlem Adı</th>
              <th>Değer</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in datas" :key="index">
              <td>{{ ++index }}</td>
              <td>{{ data.name }}</td>
              <td>{{ data.context }}</td>
            </tr>
            <tr>
              <td v-if="datas.length == 0" colspan="6" class="text-center">
                Kayıt Bulunamadı
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- /.card-body -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      overlay: false,
      datas: [],
    };
  },
  
  methods: {
    getData() {
      this.overlay = true;
      this.$http
        .get("Insiyatif/ListInsiyatifReport/" + this.$route.params.id)
        .then((response) => {
          this.datas = response.data;
          this.overlay = false;
        });
    },
  },
  created() {
    this.getData();
  },
  watch: {
    "$route.params.id"() {
      this.getData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Insiyatif/InsiyatifReport.vue